import { useCallback, useState } from 'react';
import { ff } from '@atlassian/jira-feature-flagging';
import { useJiraServiceManagementProjectNavigation } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/project-sidebar-navigation-resource/index.tsx';
import { servicedeskPracticesResource } from '@atlassian/jira-router-resources-service-desk-practices/src/controllers/index.tsx';
import type { Feature } from '@atlassian/jira-servicedesk-common/src/service-project-features/types.tsx';
import { useResource } from '@atlassian/react-resource-router';
import useServiceProjectFeaturesController from '../../common/service-project-features-controller/index.tsx';
import useFlags from './flags';
import type { UpdateProps } from './types';

const usePracticeFeaturesController = () => {
	const { data, saving, update: updateFeature } = useServiceProjectFeaturesController();
	const { showSuccessFlag, showErrorFlag } = useFlags();
	const { refresh: refreshPractices } = useResource(servicedeskPracticesResource);
	const { refresh: refreshJSMNavigation } = useJiraServiceManagementProjectNavigation();
	const [paymentError, setPaymentError] = useState<Partial<Record<Feature, boolean>>>({});

	const update = useCallback(
		({ feature, enabled }: UpdateProps) => {
			updateFeature({
				feature,
				enabled,
				onSuccess: () => {
					refreshPractices();
					refreshJSMNavigation();
					showSuccessFlag(feature, enabled);
				},
				onFail: (error) => {
					if (ff('enable_jsm_repackaging_changes_vtwk9') && error.statusCode === 402) {
						setPaymentError({
							...paymentError,
							[feature]: true,
						});
					} else {
						showErrorFlag(feature, enabled);
					}
				},
			});
		},
		[
			refreshPractices,
			refreshJSMNavigation,
			showErrorFlag,
			showSuccessFlag,
			updateFeature,
			paymentError,
		],
	);

	return { data, saving, update, paymentError };
};

export default usePracticeFeaturesController;
